/* ANIMUS · Test de piel «Encuentra tu rutina» (/pages/test-de-piel).
   Sin librerias. La logica vive en assets/animus-test-logica.json (editor cientifico de Persefone).
   Privacidad: las respuestas quedan en sessionStorage de este navegador. A GA4 y al carrito solo
   viajan p1 (objetivo), p2 (tipo de piel), p9 (simple o completa) y la version. Nunca p3, p4 ni p5. */
(function () {
  'use strict';

  var raiz = document.getElementById('an-test');
  if (!raiz || raiz.getAttribute('data-montado')) return;
  raiz.setAttribute('data-montado', '1');

  /* Solo en esta pagina: el pixel de Meta deja de leer el texto de los botones (eventos automaticos)
     y Clarity deja de grabar. Asi ninguna respuesta del test sale en esos servicios. */
  var clarityParada = false;
  function blindar() {
    try { if (typeof window.fbq === 'function') window.fbq('set', 'autoConfig', false); } catch (e) {}
    try { if (!clarityParada && typeof window.clarity === 'function') { window.clarity('stop'); clarityParada = true; } } catch (e) {}
  }
  blindar();
  window.addEventListener('load', blindar);
  raiz.addEventListener('pointerdown', blindar, true);

  var CLAVE = 'an_test_v1';
  var MAPA_P8 = { limpiador: 'limpiar', suero: 'tratar', hidratante: 'hidratar', contorno: 'contorno' };
  var NOMBRE_PASO = { limpiar: 'Limpiar', preparar: 'Preparar', tratar: 'Tratar', contorno: 'Contorno de ojos', hidratar: 'Hidratar' };
  var MOMENTO_TXT = { manana: 'Mañana', noche: 'Noche', manana_y_noche: 'Mañana y noche' };
  var RETINOIDES = ['suero-triactive-retinoid-nad', 'contorno-de-retinaldehido'];
  var EXFOLIANTES = ['suero-exfoliante-bha-2-aha-0-5', 'suero-exfoliante-nova-pha'];

  var ICONO = {
    flecha: '<svg class="an-test-icono" viewBox="0 0 192 192" fill="none" aria-hidden="true"><path d="M30 96H162" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M108 42L162 96L108 150" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    check: '<svg viewBox="0 0 15 12" fill="#fff" aria-hidden="true"><path d="M11.65 1.55l1.56 1.26-5.67 7-.38.46-4.66-3.78 1.26-1.55 3.12 2.52z"/></svg>'
  };

  var L = null;               // logica
  var S = cargar();           // estado
  var cache = {};             // promesas de /products/handle.js
  var datos = {};             // productos ya cargados
  var fallos = {};            // handles que no cargaron por red (se reintentan)
  var enviando = false;

  function cargar() {
    var base = { r: {}, pantalla: 'entrada', fuera: [], cambios: {}, tamanos: {} };
    try {
      var v = JSON.parse(sessionStorage.getItem(CLAVE) || 'null');
      if (v && v.r) return Object.assign(base, v);
    } catch (e) {}
    return base;
  }
  function guardar() { try { sessionStorage.setItem(CLAVE, JSON.stringify(S)); } catch (e) {} }

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cop(centavos) { return '$' + Math.round(centavos / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function incluye(lista, v) { return Array.isArray(lista) && lista.indexOf(v) > -1; }
  function mide(evento, datos) {
    try { if (typeof window.gtag === 'function') window.gtag('event', evento, Object.assign({ test_version: L ? L.version : '' }, datos || {})); } catch (e) {}
  }

  /* ---------- preguntas ---------- */
  function pregunta(id) { for (var i = 0; i < L.preguntas.length; i++) if (L.preguntas[i].id === id) return L.preguntas[i]; return null; }
  function usa(ids) { var p6 = S.r.p6 || []; return ids.some(function (x) { return incluye(p6, x); }); }
  function secuencia() {
    var s = ['p1', 'p2', 'p3', 'p4', 'p6'];
    if (usa(['limpiador', 'suero', 'hidratante', 'contorno'])) s.push('p7');
    if (S.r.p7 === 'sumar' && usa(['limpiador', 'suero', 'hidratante', 'contorno'])) s.push('p8');
    if (S.r.p4 !== 'menos_18') s.push('p9');
    s.push('p5');
    return s;
  }
  function opciones(q) {
    if (q.id === 'p8') {
      var p6 = S.r.p6 || [];
      return q.opciones.filter(function (o) { return incluye(p6, o.id); });
    }
    return q.opciones;
  }

  /* ---------- motor ---------- */
  function respuestas() {
    var r = Object.assign({}, S.r);
    if (r.p4 === 'menos_18') r.p9 = 'simple';
    return r;
  }
  function cumple(cond, r) {
    return ['p1', 'p2', 'p3', 'p4', 'p5', 'p9'].every(function (k) {
      var v = cond[k];
      if (v === undefined || v === 'todas') return true;
      return incluye(v, r[k]);
    });
  }
  function buscarRutina(r) {
    for (var i = 0; i < L.rutinas.length; i++) {
      var ru = L.rutinas[i];
      for (var j = 0; j < ru.condiciones.length; j++) if (cumple(ru.condiciones[j], r)) return ru;
    }
    return null;
  }
  function regla(id) { for (var i = 0; i < L.reglas.length; i++) if (L.reglas[i].id === id) return L.reglas[i]; return {}; }
  function permitido(handle, paso, r) {
    var v1 = regla('V01'), v3 = regla('V03'), v4 = regla('V04');
    if (r.p5 === 'si' && (incluye(v1.excluye_handles, handle) || incluye(RETINOIDES, handle))) return false;
    if (r.p3 === 'con_facilidad') {
      if (incluye(v3.excluye_handles, handle)) return false;
      if (paso === 'tratar' && v3.tratar_permitido && !incluye(v3.tratar_permitido, handle)) return false;
    }
    if (r.p4 === 'menos_18' && v4.permitidos_resultantes && !incluye(v4.permitidos_resultantes, handle)) return false;
    return true;
  }
  var GEL = 'gel-hidratante-todo-tipo-de-piel-especial-para-piel-mixta-grasa';
  // reglas de combinacion C01 a C06 y F03 sobre la rutina completa (revision de codigo B2)
  function combinacionValida(pasos, r, p8) {
    var act = pasos.filter(function (p) { return !p.mantiene; });
    var hs = act.map(function (p) { return p.handle; });
    var c3 = regla('C03'), c4 = regla('C04'), f3 = regla('F03');
    function cuenta(lista) { return hs.filter(function (h) { return incluye(lista, h); }).length; }
    if (cuenta(c3.inicio_gradual) > (c3.maximo || 1)) return false;                                   // C01 y C03
    if (cuenta(RETINOIDES) > 1) return false;                                                          // C02
    if (cuenta(c4.kojico_sin_enjuague) > 1 || cuenta(c4.arbutina) > 1) return false;                   // C04
    if (r.p3 !== 'casi_nunca' && incluye(hs, 'limpiador-facial-bha-2-piel-grasa-con-tendencia-a-acne')
      && incluye(hs, 'suero-exfoliante-bha-2-aha-0-5')) return false;                                  // C05
    var suero = act.filter(function (p) { return p.paso === 'tratar'; })[0];
    var hidr = act.filter(function (p) { return p.paso === 'hidratar'; })[0];
    if (suero && hidr && (incluye(RETINOIDES, suero.handle) || incluye(EXFOLIANTES, suero.handle)) && hidr.handle !== GEL) return false; // C06
    if (incluye(p8, 'suero') && hs.some(function (h) {
      return (f3.reemplazos && f3.reemplazos[h]) || incluye(RETINOIDES, h) || incluye(EXFOLIANTES, h);
    })) return false;                                                                                  // F03 y AV15
    return true;
  }
  function conCambio(pasos, q, h) {
    return pasos.map(function (x) { return x === q ? { paso: x.paso, handle: h, mantiene: x.mantiene } : x; });
  }
  function aplica(condicion, r) {
    if (!condicion) return false;
    return Object.keys(condicion).every(function (k) { return incluye(condicion[k], r[k]); });
  }
  function armar() {
    var r = respuestas();
    var ru = buscarRutina(r);
    if (!ru) return null;
    var p8 = S.r.p7 === 'sumar' ? (S.r.p8 || []) : [];
    var f3 = regla('F03');
    var pasos = ru.pasos.map(function (p, i) {
      var q = Object.assign({}, p, { i: i });
      if (incluye(p8, 'suero') && f3.reemplazos && f3.reemplazos[q.handle]) {
        var dest = q.handle.indexOf('limpiador') === 0 ? f3.limpiador_suave_segun_p2[r.p2]
          : q.handle === 'emulsion-hidratante-iluminadora' ? ((r.p2 === 'grasa' || r.p2 === 'mixta') ? 'hydra-balance' : GEL)
          : f3.reemplazos[q.handle];
        q = Object.assign(q, { handle: dest, variante: null, inicio: null, avisos_producto: null, porque: null, sustituido: true });
      }
      q.mantiene = incluye(p8, Object.keys(MAPA_P8).filter(function (k) { return MAPA_P8[k] === q.paso; })[0]);
      return q;
    });
    // cambios guardados: en orden de paso, solo si la rutina completa sigue cumpliendo vetos y combinaciones
    // dos pasadas: un cambio que dependía de otro posterior también se aplica
    [0, 1].forEach(function () {
      Object.keys(S.cambios || {}).map(Number).sort(function (x, y) { return x - y; }).forEach(function (i) {
        var q = pasos[i], h = S.cambios[i], orig = ru.pasos[i];
        if (!q || q.mantiene || !h || h === q.handle) return;
        if (h !== orig.handle && !incluye(orig.cambiar_por, h)) return;
        if (!permitido(h, q.paso, r) || !combinacionValida(conCambio(pasos, q, h), r, p8)) return;
        Object.assign(q, { handle: h, variante: null, inicio: null, avisos_producto: null, porque: null, cambiado: true });
      });
    });
    pasos.forEach(function (q) {
      var orig = ru.pasos[q.i];
      q.cambiar_por = q.mantiene ? [] : [orig.handle].concat(orig.cambiar_por || []).filter(function (h, k, a) {
        return h !== q.handle && a.indexOf(h) === k && permitido(h, q.paso, r) && combinacionValida(conCambio(pasos, q, h), r, p8);
      });
      // el consejo condicional es del producto original: no se muestra si el paso cambio
      if (!q.inicio && q.inicio_si && !q.cambiado && !q.sustituido && aplica(q.inicio_si.condicion, r)) q.inicio = q.inicio_si.texto;
      q.momento = momentoDe(q.handle, orig.momento);
    });
    var sueroCambiado = pasos.some(function (p) { return p.paso === 'tratar' && (p.cambiado || p.mantiene); });
    var yaHayRetinoide = pasos.some(function (p) { return !p.mantiene && incluye(RETINOIDES, p.handle); });   // C02: nunca sugerir un segundo retinoide
    var siguiente = ru.siguiente_paso && !sueroCambiado && !yaHayRetinoide && r.p3 !== 'con_facilidad' && r.p4 !== 'menos_18' && r.p5 !== 'si'
      && permitido(ru.siguiente_paso.handle, 'tratar', r) ? ru.siguiente_paso : null;
    return { rutina: ru, r: r, pasos: pasos, siguiente: siguiente, p8: p8 };
  }
  function momentoDe(handle, porDefecto) {
    var h = regla('H01');
    if (incluye(h.manana, handle)) return 'manana';
    if (incluye(h.noche, handle)) return 'noche';
    return porDefecto && !incluye(['manana', 'noche'], porDefecto) ? porDefecto : 'manana_y_noche';
  }
  function avisosGenerales(a) {
    var r = a.r, lista = [], activos = a.pasos.filter(function (p) { return !p.mantiene && !incluye(S.fuera, p.i); });
    var hayRet = activos.some(function (p) { return incluye(RETINOIDES, p.handle); });
    var hayExf = activos.some(function (p) { return incluye(EXFOLIANTES, p.handle); });
    function av(id) { for (var i = 0; i < L.avisos.length; i++) if (L.avisos[i].id === id) return L.avisos[i]; return null; }
    if (r.p5 === 'si') lista.push(av('AV07'));
    if (r.p3 === 'con_facilidad') lista.push(av('AV11'));
    if (a.p8.indexOf('suero') > -1) lista.push(av('AV15'));
    if ((incluye(a.p8, 'limpiador') || incluye(a.p8, 'hidratante')) && (hayRet || hayExf)) lista.push(av('AV16'));
    if (incluye(['a_veces', 'con_facilidad', 'prefiero_no'], r.p3)) lista.push(av('AV12'));
    if (r.p1 === 'imperfecciones') lista.push(av('AV13'));
    return { destacados: lista.filter(Boolean), empezar: hayRet && hayExf ? L.como_empezar.ambos : hayRet ? L.como_empezar.retinal : hayExf ? L.como_empezar.exfoliante : '' };
  }

  /* ---------- catalogo en vivo ---------- */
  function espera(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }
  // maximo 4 pedidos de producto a la vez, para no disparar la proteccion de la tienda
  var cola = [], enCurso = 0, MAX_FETCH = 4;
  function turno(fn) {
    return new Promise(function (ok, no) {
      cola.push(function () {
        enCurso++;
        fn().then(ok, no).then(function () { enCurso--; if (cola.length) cola.shift()(); });
      });
      if (enCurso < MAX_FETCH) cola.shift()();
    });
  }
  function producto(handle) {
    if (cache[handle]) return cache[handle];
    function intento(n) {
      return turno(function () { return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }); })
        .then(function (res) {
          if (res.status === 404) return null;          // no existe o no esta publicado: no se reintenta
          if (!res.ok) throw new Error('http ' + res.status);
          return res.json();
        })
        .catch(function () { return n < 3 ? espera(700 * n).then(function () { return intento(n + 1); }) : undefined; });
    }
    cache[handle] = intento(1).then(function (prod) {
      if (prod === undefined) { delete cache[handle]; fallos[handle] = true; return null; }
      delete fallos[handle];
      if (prod) datos[handle] = prod;
      return prod;
    });
    return cache[handle];
  }
  function varianteElegida(p, prod) {
    if (!prod || !prod.variants) return null;
    var vs = prod.variants;
    var elegida = S.tamanos[p.handle] ? vs.filter(function (v) { return String(v.id) === String(S.tamanos[p.handle]); })[0] : null;
    if (!elegida && p.variante) elegida = vs.filter(function (v) { return String(v.id) === String(p.variante); })[0];
    if (!elegida) elegida = vs.filter(function (v) { return v.available; })[0] || vs[0];
    if (elegida && !elegida.available) {
      var otra = p.variante_mismo_producto_si_agotado ? vs.filter(function (v) { return String(v.id) === String(p.variante_mismo_producto_si_agotado) && v.available; })[0] : null;
      elegida = otra || vs.filter(function (v) { return v.available; })[0] || elegida;
    }
    return elegida;
  }
  function resolverStock(a) {
    var handles = [];
    a.pasos.forEach(function (p) { handles.push(p.handle); handles = handles.concat(p.cambiar_por); });
    if (a.siguiente) handles.push(a.siguiente.handle);
    (L.color || []).forEach(function (c) { handles.push(c.handle); });
    return Promise.all(handles.map(producto)).then(function () {
      var tareas = a.pasos.map(function (p) {
        return producto(p.handle).then(function (prod) {
          if (!prod && fallos[p.handle]) { p.fallo = true; return; }   // red: no es agotado, no se reemplaza
          p.fallo = false;
          var v = varianteElegida(p, prod);
          if (prod && v && v.available) { p.prod = prod; p.v = v; return; }
          // agotado: primera alternativa disponible
          var alt = p.cambiar_por.slice();
          function probar() {
            if (!alt.length) { p.prod = prod; p.v = v; p.agotado = true; return; }
            var h = alt.shift();
            return producto(h).then(function (pa) {
              var va = varianteElegida({ handle: h }, pa);
              if (pa && va && va.available) { p.reemplazoDe = prod ? prod.title : p.handle; p.handle = h; p.prod = pa; p.v = va; p.porque = null; p.inicio = null; p.avisos_producto = null; p.momento = momentoDe(h, 'manana_y_noche'); }
              else return probar();
            });
          }
          return probar();
        });
      });
      return Promise.all(tareas);
    });
  }

  /* ---------- pintura ---------- */
  function pinta(dir) {
    if (S.pantalla === 'entrada') return pintaEntrada();
    if (S.pantalla === 'resultado') return pintaResultado();
    return pintaPregunta(S.pantalla);
  }
  function pintaEntrada() {
    // si la entrada ya viene pintada desde el servidor y no hay respuestas guardadas, se deja tal cual (sin parpadeo)
    if (raiz.querySelector('.an-test-entrada[data-ssr]') && !Object.keys(S.r).length) return;
    var img = raiz.getAttribute('data-imagen');
    raiz.innerHTML =
      '<section class="an-test-entrada" aria-labelledby="an-test-t0">' +
      (img ? '<figure class="an-test-entrada__media" aria-hidden="true"><img src="' + esc(img) + '" alt="" width="1000" height="1000"></figure>' : '') +
      '<div class="an-test-entrada__in">' +
      '<p class="an-test-etiqueta an-test-entra">Test de rutina</p>' +
      '<h1 class="an-test-entrada__titulo an-test-entra an-test-entra-2" id="an-test-t0" tabindex="-1">Encuentra tu rutina</h1>' +
      '<p class="an-test-entrada__texto an-test-entra an-test-entra-3">Responde unas preguntas cortas y te sugerimos una rutina ÁNIMUS de 3 o 5 pasos, lista para comprar.</p>' +
      '<div class="an-test-entrada__acciones an-test-entra an-test-entra-4">' +
      '<button type="button" class="an-test-boton an-test-boton--claro" data-accion="empezar">' + (Object.keys(S.r).length ? 'Seguir donde ibas' : 'Empezar') + '</button>' +
      (Object.keys(S.r).length ? '<button type="button" class="an-test-enlace" data-accion="reiniciar">Empezar de nuevo</button>' : enlaceAsesoria(null, 'Prefiero asesoría por WhatsApp', '')) +
      '</div></div></section>' +
      '<div class="an-test-entrada__pie">' +
      '<p class="an-test-nota">Tus respuestas sirven para mostrarte una rutina en esta pantalla. No te pedimos nombre ni contacto para verla. Lo que nos cuentes sobre sensibilidad, edad y embarazo solo lo usa tu navegador y no nos llega.</p>' +
      '<p class="an-test-nota">Es una orientación cosmética. No reemplaza la consulta con tu dermatólogo.</p></div>';
    enfoca('#an-test-t0');
  }
  function pintaPregunta(id) {
    var q = pregunta(id), seq = secuencia(), idx = seq.indexOf(id);
    if (!q || idx < 0) { S.pantalla = seq[0]; return pintaPregunta(seq[0]); }
    var multiple = q.tipo === 'multiple', sel = S.r[id];
    var ops = opciones(q).map(function (o) {
      var on = multiple ? incluye(sel, o.id) : sel === o.id;
      return '<li><button type="button" class="an-test-opcion" aria-pressed="' + on + '" data-op="' + esc(o.id) + '">' +
        '<span>' + esc(o.texto) + (o.detalle ? '<span class="an-test-opcion__sub">' + esc(o.detalle) + '</span>' : '') + '</span>' +
        '<span class="an-test-opcion__marca">' + ICONO.check + '</span></button></li>';
    }).join('');
    var barras = seq.map(function (x, k) { return '<li' + (k <= idx ? ' data-lleno' : '') + '></li>'; }).join('');
    raiz.innerHTML =
      '<div class="an-test-pasos"><div class="an-test-barra"><div class="an-test-barra__fila">' +
      '<button type="button" class="an-test-atras" data-accion="atras">' + ICONO.flecha + 'Atrás</button>' +
      '<p class="an-test-etiqueta" aria-live="polite">Pregunta ' + (idx + 1) + '</p></div>' +
      '<ol class="an-test-progreso" aria-hidden="true">' + barras + '</ol></div>' +
      '<div class="an-test-pregunta">' +
      '<h2 class="an-test-pregunta__titulo an-test-entra" id="an-test-q" tabindex="-1">' + esc(q.texto) + '</h2>' +
      (q.ayuda ? '<p class="an-test-ayuda an-test-entra">' + esc(q.ayuda) + '</p>' : '<p class="an-test-ayuda"></p>') +
      '<ul class="an-test-opciones an-test-entra an-test-entra-2" role="group" aria-labelledby="an-test-q" data-pregunta="' + id + '"' + (multiple ? ' data-multiple' : '') + '>' + ops + '</ul>' +
      (multiple ? '<p class="an-test-continuar"><button type="button" class="an-test-boton an-test-boton--ancho" data-accion="continuar"' + ((sel && sel.length >= (q.minimo || 1)) ? '' : ' disabled') + '>Continuar</button></p>' : '') +
      '</div></div>';
    enfoca('#an-test-q');
  }
  function enfoca(sel) {
    var t = raiz.querySelector(sel);
    if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
    var y = raiz.getBoundingClientRect().top + window.pageYOffset - 80;
    if (window.pageYOffset > y) window.scrollTo(0, Math.max(0, y));
  }

  // suave: repintado por un toque dentro del resultado (sin pantalla de carga, sin animacion y sin mover el scroll)
  function pintaResultado(suave) {
    var firma = JSON.stringify([S.r.p1, S.r.p2, S.r.p3, S.r.p4, S.r.p5, S.r.p9, S.r.p7, S.r.p8]);
    if (S.firma !== firma) { S.cambios = {}; S.fuera = []; S.tamanos = {}; S.medido = false; S.firma = firma; guardar(); }
    var a = armar();
    if (!a) { S.pantalla = secuencia().filter(function (x) { return S.r[x] === undefined; })[0] || 'p1'; guardar(); return pinta(); }
    if (suave) raiz.setAttribute('data-suave', ''); else raiz.removeAttribute('data-suave');
    if (!suave) raiz.innerHTML = '<div class="an-test-resultado"><p class="an-test-etiqueta">Preparando tu rutina</p></div>';
    resolverStock(a).then(function () { dibujaResultado(a, suave); }).catch(function () { dibujaResultado(a, suave); });
  }
  function dibujaResultado(a, suave) {
    var r = a.r, gen = avisosGenerales(a), yAntes = window.pageYOffset;
    var titulo = r.p3 === 'con_facilidad' ? 'Una base suave para empezar' : 'Tu rutina sugerida';
    var p1 = pregunta('p1').opciones.filter(function (o) { return o.id === r.p1; })[0];
    var p2 = pregunta('p2').opciones.filter(function (o) { return o.id === r.p2; })[0];
    var piel = p2 ? (r.p2 === 'no_segura' ? 'no tienes claro tu tipo de piel' : (p2.detalle || p2.texto).toLowerCase()) : '';
    var resumen = 'Nos contaste: ' + (p1 ? p1.texto.toLowerCase() : '') + (piel ? ', ' + piel : '') + '.';
    var n = 0, total = 0, lineas = [];
    var tarjetas = a.pasos.map(function (p, k) {
      var num = (k + 1 < 10 ? '0' : '') + (k + 1);
      var cab = '<div class="an-test-paso-cab"><span class="an-test-num">' + num + '</span><span class="an-test-etiqueta">' + esc(NOMBRE_PASO[p.paso] || p.paso) + ' · ' + esc(MOMENTO_TXT[p.momento] || '') + '</span></div>';
      if (p.mantiene) return '<li>' + cab + '<p class="an-test-aviso an-test-aviso--suave">Sigues con tu ' + esc(Object.keys(MAPA_P8).filter(function (x) { return MAPA_P8[x] === p.paso; })[0] || 'producto') + ' actual.</p></li>';
      var prod = p.prod, v = p.v;
      if (!prod || !v) {
        if (fallos[p.handle]) return '<li>' + cab + '<p class="an-test-aviso">No pudimos cargar este producto. <button type="button" class="an-test-enlace an-test-enlace--linea" data-accion="reintentar">Intentar de nuevo</button></p></li>';
        return '<li>' + cab + '<p class="an-test-aviso">Este paso no está disponible por ahora.' + (r.p4 === 'menos_18' ? '' : ' ' + enlaceAsesoria(r, 'Pide asesoría', 'an-test-enlace--linea')) + '</p></li>';
      }
      var fuera = incluye(S.fuera, p.i) || p.agotado || !v.available;
      if (!fuera) { n++; total += v.price; }
      lineas.push({ nombre: prod.title, precio: v.price, fuera: fuera });
      var img = prod.featured_image ? (prod.featured_image.indexOf('//') === 0 ? 'https:' + prod.featured_image : prod.featured_image) : '';
      var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=352' : '';
      var tamanos = prod.variants.length > 1 && prod.variants.length < 4 ? '<div class="an-test-tamanos" role="group" aria-label="Tamaño">' + prod.variants.map(function (x) {
        return '<button type="button" aria-pressed="' + (String(x.id) === String(v.id)) + '" data-tamano="' + x.id + '" data-handle="' + esc(p.handle) + '"' + (x.available ? '' : ' disabled') + '>' + esc(x.title) + '</button>';
      }).join('') + '</div>' : '';
      var precio = '<p class="an-test-precio"><span class="an-test-precio__actual">' + cop(v.price) + '</span>' +
        (v.compare_at_price && v.compare_at_price > v.price ? '<span class="an-test-precio__antes">' + cop(v.compare_at_price) + '</span><span class="an-test-ahorra">Ahorra</span>' : '') + '</p>';
      var porque = p.porque || '';
      var avisos = [];
      if (p.reemplazoDe) avisos.push(textoAviso('AV20'));
      // si hay bloque «Cómo empezar», el inicio del retinoide o exfoliante no se repite en la tarjeta
      if (p.inicio && !(gen.empezar && (incluye(RETINOIDES, p.handle) || incluye(EXFOLIANTES, p.handle)))) avisos.push(p.inicio);
      if (incluye(RETINOIDES, p.handle)) { avisos.push(textoAviso('AV09')); avisos.push(textoAviso('AV10')); }
      var cambiar = p.cambiar_por.length ? '<button type="button" class="an-test-enlace" data-accion="abrir-cambio" data-paso="' + p.i + '" aria-expanded="' + (S.abierto === p.i) + '">Cambiar</button>' : '';
      var panel = S.abierto === p.i && p.cambiar_por.length ? '<div class="an-test-cambio" role="group" aria-label="Cambiar producto">' + p.cambiar_por.map(function (h) {
        return '<button type="button" class="an-test-opcion" data-accion="cambiar" data-paso="' + p.i + '" data-handle="' + esc(h) + '"><span data-nombre-de="' + esc(h) + '">' + esc(h.replace(/-/g, ' ')) + '</span><span class="an-test-opcion__marca">' + ICONO.check + '</span></button>';
      }).join('') + '</div>' : '';
      return '<li class="an-test-entra">' + cab +
        '<article class="an-test-producto"' + (fuera ? ' data-excluido' : '') + '>' +
        '<a class="an-test-producto__foto" href="' + esc(prod.url) + '" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(src) + '" alt="" width="176" height="220" loading="lazy">' : '') + '</a>' +
        '<div><h3 class="an-test-producto__nombre"><a href="' + esc(prod.url) + '">' + esc(prod.title) + '</a></h3>' + precio + tamanos + '</div>' +
        (porque ? '<p class="an-test-producto__porque">' + esc(porque) + '</p>' : '') +
        avisos.filter(Boolean).map(function (t) { return '<p class="an-test-producto__porque an-test-nota">' + esc(t) + '</p>'; }).join('') +
        (p.agotado || !v.available ? '<p class="an-test-producto__porque">Agotado por ahora.</p>' : '') +
        '<div class="an-test-producto__acciones">' + (cambiar || '<a class="an-test-enlace" href="' + esc(prod.url) + '">Ver detalles</a>') +
        (p.agotado || !v.available ? '' : '<button type="button" class="an-test-enlace an-test-quitar" data-accion="quitar" data-paso="' + p.i + '">' + (incluye(S.fuera, p.i) ? 'Volver a incluir' : 'Ya lo tengo') + '</button>') +
        '</div>' + panel + '</article></li>';
    }).join('');

    var siguiente = '';
    if (a.siguiente) {
      siguiente = '<div class="an-test-asesoria"><p class="an-test-etiqueta">Siguiente paso, más adelante</p>' +
        '<p>' + esc(textoAviso('AV17')) + '</p><p>' + esc(a.siguiente.porque || '') + '</p>' +
        '<p class="an-test-nota">' + esc(textoAviso('AV09')) + ' ' + esc(a.siguiente.inicio || '') + '</p>' +
        '<a class="an-test-enlace" href="/products/' + esc(a.siguiente.handle) + '">Ver el producto</a></div>';
    }
    var hayColor = (L.color || []).some(function (c) { return !aplica(c.oculto_si, r) && datos[c.handle]; });
    var color = hayColor ? '<div class="an-test-asesoria an-test-color" data-color>' + htmlColor(r) + '</div>' : '';

    var destacados = gen.destacados.map(function (x) {
      var extra = x.id === 'AV11' && r.p4 !== 'menos_18' ? ' ' + enlaceAsesoria(r, 'Pedir asesoría', 'an-test-enlace--linea') : '';
      return '<p class="an-test-aviso">' + esc(x.texto) + extra + '</p>';
    }).join('');
    var todoMantiene = a.pasos.every(function (p) { return p.mantiene; });
    var boton = function (clase) {
      return '<button type="button" class="an-test-boton ' + clase + '" data-accion="comprar"' + (n ? '' : ' disabled') + '>' + (n ? 'Comprar mi rutina' : 'Elige al menos un producto') + '</button>';
    };
    var lista = lineas.map(function (l) { return '<li' + (l.fuera ? ' data-excluido' : '') + '><span>' + esc(l.nombre) + '</span><span>' + cop(l.precio) + '</span></li>'; }).join('');

    raiz.innerHTML =
      '<div class="an-test-resultado"><header class="an-test-entra">' +
      '<p class="an-test-etiqueta">Test de rutina · ' + (r.p9 === 'completa' ? '5 pasos' : '3 pasos') + '</p>' +
      '<h1 class="an-test-resultado__titulo" id="an-test-rt" tabindex="-1">' + esc(titulo) + '</h1>' +
      '<p class="an-test-resumen">' + esc(resumen) + ' <button type="button" class="an-test-enlace an-test-enlace--linea" data-accion="cambiar-respuestas">Cambiar respuestas</button></p>' +
      '</header><div class="an-test-resultado__grid"><div>' +
      (destacados ? '<div class="an-test-cierre an-test-arriba">' + destacados + '</div>' : '') +
      (todoMantiene ? '<p class="an-test-aviso an-test-arriba">' + esc(textoAviso('AV19')) + '</p>' : '') +
      '<ol class="an-test-rutina">' + tarjetas + '</ol>' +
      (gen.empezar ? '<div class="an-test-asesoria an-test-arriba"><p class="an-test-etiqueta">Cómo empezar</p><p>' + esc(gen.empezar) + '</p></div>' : '') +
      siguiente + color +
      '<div class="an-test-cierre">' +
      ['AV03', 'AV04', 'AV05', 'AV06'].map(function (id) { return '<p class="an-test-aviso an-test-aviso--suave">' + esc(textoAviso(id)) + '</p>'; }).join('') +
      '<details class="an-test-asesoria an-test-detalle"><summary>' + esc(tituloAviso('AV18')) + '</summary><p>' + esc(textoAviso('AV18')) + '</p></details>' +
      (r.p4 === 'menos_18' ? '' : '<div class="an-test-asesoria"><h2>¿Quieres asesoría ahora?</h2><p>Escríbenos por WhatsApp y recibe tu asesoría gratis de inmediato.</p>' + enlaceAsesoria(r, 'Recibir mi asesoría', '') + '</div>') +
      '<p class="an-test-nota">' + esc(textoAviso('AV02')) + ' ' + esc(textoAviso('AV01')) + '</p>' +
      '<button type="button" class="an-test-enlace" data-accion="reiniciar">Empezar de nuevo</button>' +
      '<p class="an-test-nota" data-mensaje role="status" aria-live="polite"></p>' +
      '</div></div>' +
      '<aside class="an-test-compra-panel" aria-label="Tu rutina"><p class="an-test-etiqueta">Tu rutina · ' + n + (n === 1 ? ' producto' : ' productos') + '</p><ul>' + lista + '</ul>' +
      '<div class="an-test-compra-panel__total"><span>Subtotal</span><strong>' + cop(total) + '</strong></div>' +
      '<p class="an-test-nota an-test-compra-panel__envio">El envío se calcula al pagar.</p>' + boton('an-test-boton--ancho') +
      (n ? '<p class="an-test-compra-panel__agregar"><button type="button" class="an-test-enlace" data-accion="agregar">Agregar al carrito y seguir viendo</button></p>' : '') + '</aside>' +
      '</div></div>' +
      '<div class="an-test-compra-barra" data-visible><div><span class="an-test-etiqueta">' + n + (n === 1 ? ' producto' : ' productos') + '</span><span class="an-test-compra-barra__total">' + (n ? cop(total) : '') + '</span></div>' + boton('') + '</div>';

    if (suave) window.scrollTo(0, yAntes);
    // nombres reales en el panel Cambiar
    raiz.querySelectorAll('[data-nombre-de]').forEach(function (el) {
      producto(el.getAttribute('data-nombre-de')).then(function (pr) { if (pr) el.textContent = pr.title; });
    });
    if (!S.medido) { S.medido = true; guardar(); mide('test_resultado', { test_objetivo: r.p1, test_piel: r.p2, test_rutina: r.p9 }); }
    if (!suave) enfoca('#an-test-rt');
  }

  /* ---------- asesoria por WhatsApp (sin sensibilidad, edad ni embarazo en el mensaje) ---------- */
  function enlaceWhatsapp(r) {
    var base = raiz.getAttribute('data-whatsapp') || '';
    if (!base) return '/pages/asesoria';
    var t = 'Hola, quiero mi asesoría de rutina.';
    if (r && r.p1 && L) {
      var o1 = pregunta('p1').opciones.filter(function (o) { return o.id === r.p1; })[0];
      var o2 = pregunta('p2').opciones.filter(function (o) { return o.id === r.p2; })[0];
      t = 'Hola, hice el test de piel en animuslb.com y quiero mi asesoría.' +
        (o1 ? ' Quiero mejorar: ' + o1.texto.toLowerCase() + '.' : '') +
        (o2 && r.p2 !== 'no_segura' && o2.detalle ? ' Mi piel: ' + o2.detalle.toLowerCase() + '.' : '');
    }
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(t);
  }
  function enlaceAsesoria(r, texto, clase) {
    return '<a class="an-test-enlace' + (clase ? ' ' + clase : '') + '" href="' + esc(enlaceWhatsapp(r)) + '" target="_blank" rel="noopener" data-asesoria>' + esc(texto) + '</a>';
  }

  /* ---------- Skincare + Color: ayuda de tono y Agregar ---------- */
  var SUBTONO = [['calida', 'Dorados'], ['fria', 'Plateados'], ['neutra', 'Los dos']];
  var PROFUNDIDAD = [['clara', 'Clara'], ['media', 'Media'], ['triguena', 'Trigueña'], ['morena', 'Morena']];
  function tonoDe(c, pc) {
    var vs = pc.variants.filter(function (v) { return v.available; });
    if (!vs.length) return null;
    var tono = S.tono || {}, elegido = (S.tonoElegido || {})[c.handle];
    var v = elegido ? vs.filter(function (x) { return String(x.id) === String(elegido); })[0] : null;
    if (v) return { v: v, sugerido: false, vs: vs };
    var mapa = c.tonos_sugeridos && tono.sub && tono.prof && c.tonos_sugeridos[tono.sub] ? c.tonos_sugeridos[tono.sub][tono.prof] : '';
    v = mapa ? vs.filter(function (x) { return x.title === mapa; })[0] : null;
    return { v: v || vs[0], sugerido: !!v, vs: vs };
  }
  function chipsTono(clave, lista, titulo) {
    var tono = S.tono || {};
    return '<div class="an-test-tono__fila"><p class="an-test-tono__pregunta">' + esc(titulo) + '</p><div class="an-test-tono__chips" role="group" aria-label="' + esc(titulo) + '">' +
      lista.map(function (x) { return '<button type="button" class="an-test-chip" data-tono="' + clave + '" data-valor="' + x[0] + '" aria-pressed="' + (tono[clave] === x[0]) + '">' + esc(x[1]) + '</button>'; }).join('') + '</div></div>';
  }
  function htmlColor(r) {
    var colores = (L.color || []).filter(function (c) { return !aplica(c.oculto_si, r) && datos[c.handle]; });
    var tarjetas = colores.map(function (c) {
      var pc = datos[c.handle], t = tonoDe(c, pc);
      if (!t) return '';
      var img = (t.v.featured_image && t.v.featured_image.src) || pc.featured_image || '';
      if (img.indexOf('//') === 0) img = 'https:' + img;
      var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=320' : '';
      var opciones = t.vs.map(function (x) { return '<option value="' + x.id + '"' + (x.id === t.v.id ? ' selected' : '') + '>' + esc(x.title) + '</option>'; }).join('');
      return '<li class="an-test-color__item">' +
        '<a class="an-test-color__foto" href="' + esc(pc.url) + '" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(src) + '" alt="" width="160" height="160" loading="lazy">' : '') + '</a>' +
        '<div class="an-test-color__info"><a class="an-test-color__nombre" href="' + esc(pc.url) + '">' + esc(nombreBonito(c.nombre)) + '</a>' +
        '<span class="an-test-color__frase">' + esc(c.frase) + '</span>' +
        (t.vs.length > 1 ? '<label class="an-test-color__tono"><span class="an-test-oculto">Tono de ' + esc(nombreBonito(c.nombre)) + '</span><select data-color-tono data-handle="' + esc(c.handle) + '">' + opciones + '</select></label>' : '') +
        (t.sugerido ? '<span class="an-test-color__sugerido">Tono sugerido para ti</span>' : '') +
        '<div class="an-test-color__compra"><span class="an-test-precio__actual">' + cop(t.v.price) + '</span>' +
        '<button type="button" class="an-test-boton an-test-boton--borde" data-accion="agregar-color" data-variante="' + t.v.id + '" data-handle="' + esc(c.handle) + '">Agregar</button></div>' +
        '</div></li>';
    }).join('');
    return '<p class="an-test-etiqueta">Skincare + Color</p><h2>Color que se funde con tu piel</h2>' +
      '<div class="an-test-tono"><p class="an-test-tono__titulo">Encuentra tu tono</p>' +
      chipsTono('sub', SUBTONO, '¿Qué accesorios te favorecen?') + chipsTono('prof', PROFUNDIDAD, '¿Cómo es tu piel?') + '</div>' +
      '<ul class="an-test-color__lista">' + tarjetas + '</ul><p class="an-test-nota" data-mensaje-color role="status" aria-live="polite"></p>';
  }
  function repintaColor() {
    var caja = raiz.querySelector('[data-color]');
    if (caja && S.pantalla === 'resultado') caja.innerHTML = htmlColor(S.r);
  }
  function agregarColor(b) {
    var caja = raiz.querySelector('[data-mensaje-color]');
    b.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-variante'), quantity: 1 }] }) })
      .then(function (res) {
        if (!res.ok) throw new Error('add');
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        b.textContent = 'En tu carrito'; b.classList.add('an-test-boton--hecho'); b.setAttribute('data-hecho', '1');
        if (caja) caja.innerHTML = 'Quedó en tu carrito. <a class="an-test-enlace" href="/cart" data-ver-carrito>Ver carrito</a>';
        mide('test_agregar_color', { producto: b.getAttribute('data-handle') });
      })
      .catch(function () { if (caja) caja.textContent = 'No pudimos agregarlo. Intenta de nuevo en un momento.'; })
      .then(function () { if (!b.getAttribute('data-hecho')) b.removeAttribute('aria-disabled'); });
  }
  function textoAviso(id) { for (var i = 0; i < L.avisos.length; i++) if (L.avisos[i].id === id) return L.avisos[i].texto; return ''; }
  function tituloAviso(id) { for (var i = 0; i < L.avisos.length; i++) if (L.avisos[i].id === id) return L.avisos[i].titulo || ''; return ''; }
  function nombreBonito(t) { return t === 'BLUSH BALM' ? 'Blush Balm' : t === 'BLUSH BALM / BRONZER EDITION' ? 'Bronzer Edition' : t; }

  /* ---------- carrito ---------- */
  function lineasCarrito(a) {
    return a.pasos.filter(function (p) { return !p.mantiene && !incluye(S.fuera, p.i) && p.v && p.v.available && !p.agotado; })
      .map(function (p) { return { id: p.v.id, quantity: 1 }; });
  }
  function mensaje(t) { var m = raiz.querySelector('[data-mensaje]'); if (m) m.textContent = t; }
  function enCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) { if (!res.ok) throw new Error('cart ' + res.status); return res.json(); })
      .then(function (c) { var hay = {}; (c.items || []).forEach(function (x) { hay[x.variant_id] = true; }); return hay; });
  }
  function agregarItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }) });
  }
  function comprar(irAPagar) {
    if (enviando) return;
    var a = armar(); if (!a) return;
    enviando = true;
    raiz.querySelectorAll('[data-accion="comprar"],[data-accion="agregar"]').forEach(function (b) { b.setAttribute('aria-disabled', 'true'); });
    resolverStock(a).then(function () {
      var caidos = a.pasos.filter(function (p) { return p.fallo && !p.mantiene && !incluye(S.fuera, p.i); });
      if (caidos.length) throw new Error('red');                      // no se compra una rutina incompleta en silencio
      var items = lineasCarrito(a);
      if (!items.length) throw new Error('vacio');
      // solo se agrega lo que falta: add.js suma cantidad si la variante ya esta en el carrito
      return enCarrito().then(function (hay) {
        var nuevos = items.filter(function (it) { return !hay[it.id]; });
        var ya = items.length - nuevos.length;
        if (!nuevos.length) return { agregados: items.length, total: items.length };
        return agregarItems(nuevos).then(function (res) {
          if (res.ok) return { agregados: items.length, total: items.length };
          // el bloque fallo: se relee el carrito para no duplicar lo que alcanzo a entrar
          return enCarrito().then(function (hay2) {
            var faltan = nuevos.filter(function (it) { return !hay2[it.id]; });
            var ok = nuevos.length - faltan.length;
            return faltan.reduce(function (cadena, it) {
              return cadena.then(function () { return agregarItems([it]).then(function (r2) { if (r2.ok) ok++; }); });
            }, Promise.resolve()).then(function () { return { agregados: ya + ok, total: items.length }; });
          });
        });
      })
        .then(function (res) {
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { 'Origen': 'test-piel', 'Test objetivo': a.r.p1 || '', 'Test piel': a.r.p2 || '', 'Test rutina': a.r.p9 || '', 'Test version': L.version } }) })
            .catch(function () {}).then(function () { return res; });
        });
    }).then(function (res) {
      enviando = false;
      mide(irAPagar ? 'test_comprar' : 'test_agregar', { test_objetivo: a.r.p1, test_piel: a.r.p2, test_rutina: a.r.p9, productos: res.agregados });
      if (!res.agregados) { mensaje('No pudimos agregar los productos. Intenta de nuevo en un momento.'); return reactivar(); }
      if (res.agregados < res.total) mensaje('Agregamos ' + res.agregados + ' de ' + res.total + ' productos. Alguno se agotó hace un momento.');
      if (irAPagar && res.agregados === res.total) { window.location.href = '/checkout'; return; }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      if (res.agregados === res.total) {
        var m = raiz.querySelector('[data-mensaje]'); if (m) m.innerHTML = 'Tu rutina quedó en el carrito. <a class="an-test-enlace" href="/cart" data-ver-carrito>Ver carrito</a>';
        raiz.querySelectorAll('.an-test-compra-panel__agregar [data-accion="agregar"]').forEach(function (x) { x.textContent = 'Tu rutina está en el carrito'; });
      }
      reactivar();
    }).catch(function () {
      enviando = false;
      mensaje('No hay conexión o algo falló. Tus respuestas siguen guardadas: intenta de nuevo.');
      reactivar();
    });
  }
  function reactivar() { raiz.querySelectorAll('[aria-disabled="true"]').forEach(function (b) { b.removeAttribute('aria-disabled'); }); }

  /* ---------- navegacion ---------- */
  // la pantalla viaja en history.state; la URL conserva utm, gclid y preview (solo lleva el id de la pantalla, nunca una respuesta)
  function urlPaso(pantalla) {
    var u = new URL(location.href);
    u.searchParams.set('paso', pantalla === 'entrada' ? 'inicio' : pantalla);
    return u.pathname + u.search + u.hash;
  }
  function ir(pantalla, empuja) {
    if (S.pantalla !== pantalla && empuja !== false) {
      try { history.pushState({ anTest: pantalla }, '', urlPaso(pantalla)); } catch (e) {}
    }
    S.pantalla = pantalla; S.abierto = null; guardar(); pinta();
  }
  function siguiente(desde) {
    var seq = secuencia(), i = seq.indexOf(desde);
    // limpiar respuestas que ya no aplican
    if (seq.indexOf('p7') < 0) delete S.r.p7;
    if (seq.indexOf('p8') < 0) delete S.r.p8;
    if (S.r.p8) S.r.p8 = S.r.p8.filter(function (x) { return incluye(S.r.p6, x); });
    if (i === seq.length - 1) { S.cambios = {}; S.fuera = []; S.tamanos = {}; S.medido = false; ir('resultado'); }
    else ir(seq[i + 1]);
  }

  raiz.addEventListener('click', function (e) {
    if (!L) return;                                             // la lógica aún no cargó
    var op = e.target.closest('.an-test-opcion[data-op]');
    if (op) {
      var grupo = op.closest('[data-pregunta]'), id = grupo.getAttribute('data-pregunta'), v = op.getAttribute('data-op');
      var q = pregunta(id);
      if (grupo.hasAttribute('data-multiple')) {
        var sel = (S.r[id] || []).slice();
        if (q.exclusiva && v === q.exclusiva) sel = incluye(sel, v) ? [] : [v];
        else { sel = sel.filter(function (x) { return x !== q.exclusiva; }); sel = incluye(sel, v) ? sel.filter(function (x) { return x !== v; }) : sel.concat(v); }
        S.r[id] = sel; guardar(); pintaPregunta(id);
      } else {
        if (grupo.hasAttribute('data-bloqueado')) return;          // doble clic: no contesta la pregunta siguiente
        grupo.setAttribute('data-bloqueado', '');
        grupo.querySelectorAll('.an-test-opcion').forEach(function (b) { b.setAttribute('aria-pressed', b === op ? 'true' : 'false'); });
        S.r[id] = v; guardar();
        if (id === 'p1' && !S.inicioMedido) { S.inicioMedido = true; guardar(); mide('test_inicio', {}); }
        setTimeout(function () { siguiente(id); }, 220);
      }
      return;
    }
    var b = e.target.closest('[data-accion]');
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    var acc = b.getAttribute('data-accion');
    if (acc === 'empezar') {
      var seq = secuencia();
      var pendiente = seq.filter(function (x) { var q2 = pregunta(x); var val = S.r[x]; return val === undefined || (q2.tipo === 'multiple' && !val.length); })[0];
      ir(pendiente || 'resultado');
    }
    else if (acc === 'reiniciar') { S = { r: {}, pantalla: 'entrada', fuera: [], cambios: {}, tamanos: {} }; guardar(); try { history.replaceState({ anTest: 'entrada' }, '', urlPaso('entrada')); } catch (e2) {} pinta(); }
    else if (acc === 'atras') { history.back(); }
    else if (acc === 'continuar') { siguiente(S.pantalla); }
    else if (acc === 'cambiar-respuestas') { ir('p1'); }
    else if (acc === 'quitar') { var i = +b.getAttribute('data-paso'); S.fuera = incluye(S.fuera, i) ? S.fuera.filter(function (x) { return x !== i; }) : S.fuera.concat(i); guardar(); pintaResultado(true); }
    else if (acc === 'abrir-cambio') { var k = +b.getAttribute('data-paso'); S.abierto = S.abierto === k ? null : k; pintaResultado(true); }
    else if (acc === 'cambiar') { S.cambios[+b.getAttribute('data-paso')] = b.getAttribute('data-handle'); S.abierto = null; guardar(); pintaResultado(true); }
    else if (acc === 'reintentar') { pintaResultado(true); }
    else if (acc === 'agregar-color') { agregarColor(b); }
    else if (acc === 'comprar') { comprar(true); }
    else if (acc === 'agregar') { comprar(false); }
  });
  raiz.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tamano]');
    if (!t || t.disabled) return;
    S.tamanos[t.getAttribute('data-handle')] = t.getAttribute('data-tamano'); guardar(); pintaResultado(true);
  });
  raiz.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-tono]');
    if (chip) {
      S.tono = S.tono || {}; S.tono[chip.getAttribute('data-tono')] = chip.getAttribute('data-valor');
      S.tonoElegido = {}; guardar(); repintaColor();
      return;
    }
    if (e.target.closest('[data-asesoria]')) mide('test_asesoria', {});
  });
  raiz.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-color-tono]');
    if (!sel) return;
    S.tonoElegido = S.tonoElegido || {}; S.tonoElegido[sel.getAttribute('data-handle')] = sel.value; guardar(); repintaColor();
  });
  window.addEventListener('popstate', function (e) {
    if (!L) return;
    S.pantalla = (e.state && e.state.anTest) || 'entrada'; S.abierto = null; guardar(); pinta();
  });
  // al volver del pago desde la cache del navegador, los botones no quedan bloqueados
  window.addEventListener('pageshow', function (e) { if (e.persisted) { enviando = false; reactivar(); } });

  /* ---------- gancho de verificacion (solo en temas sin publicar; lectura del motor, sin red) ---------- */
  if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') raiz.anTestMotor = {
    evaluar: function (r, extra) {
      var copia = JSON.parse(JSON.stringify(S));
      S = Object.assign({ r: r, pantalla: 'resultado', fuera: [], cambios: {}, tamanos: {} }, extra || {});
      try { var a = armar(); return a ? { codigo: a.rutina.codigo, pasos: a.pasos.map(function (p) { return { paso: p.paso, handle: p.handle, cambiar_por: p.cambiar_por, mantiene: p.mantiene, momento: p.momento }; }), siguiente: a.siguiente ? a.siguiente.handle : null, avisos: avisosGenerales(a).destacados.map(function (x) { return x.id; }), empezar: avisosGenerales(a).empezar } : null; }
      finally { S = copia; }
    },
    secuencia: function (r) { var copia = S.r; S.r = r; try { return secuencia(); } finally { S.r = copia; } },
    listo: function () { return !!L; }
  };

  /* ---------- arranque ---------- */
  fetch(raiz.getAttribute('data-logica'), { credentials: 'same-origin' })
    .then(function (res) { if (!res.ok) throw new Error('logica'); return res.json(); })
    .then(function (json) {
      L = json;
      var st = history.state && history.state.anTest;
      var paso = new URLSearchParams(location.search).get('paso');
      if (st) S.pantalla = st; else if (!paso) S.pantalla = 'entrada';
      try { history.replaceState({ anTest: S.pantalla }, '', location.href); } catch (e) {}
      pinta();
    })
    .catch(function () {
      var f = raiz.querySelector('[data-respaldo]');
      if (f) f.hidden = false;
      raiz.querySelectorAll('[data-ssr], [data-ssr-pie]').forEach(function (el) { el.hidden = true; });
    });

  /* «Ver carrito» abre el carrito lateral del tema; si no existe, va a /cart */
  raiz.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ver-carrito]'); if (!a) return;
    var t = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (t) { e.preventDefault(); t.click(); }
  });
})();
